export default {
    modal: {
        comments: 'Comments',
        negativeQuestion: 'What do you dislike about this version?',
        neutralQuestion: 'What are your suggestions?',
        positiveQuestion: 'What do you like about this version?',
        suggestions: 'Suggestions',
    },
};
